import Vue, { CreateElement } from '@src/vue'

import { Component, Prop, Inject } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'

import { Element, SelectableElement } from '@src/mixins/element/element'
import { Selectable } from '@src/mixins/selectable/selectable'

import { Select } from '@src/elements/select/select'
import { Icon } from '@src/elements/icon/icon'
import { Checkbox } from '@src/elements/input/checkbox'

import { isMobileBrowser, stopPropagation } from '@src/util/functions'

import './select.sass'

@Component
export class Option extends Mixins<SelectableElement>(Element, Selectable) {

  @Prop({ required: true })
  value: string

  @Prop({ required: false, default: 'multiple-option' })
  type: 'single-option' | 'multiple-option'

  @Inject()
  container: Select // | MenuButton

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.selectableStyles,
      ...this.optionStyles
    ]

    return this.renderElement(h, styleClasses, this.selected, [
      this.renderIcon(h),
      this.renderLabel(h),

      this.renderCheckmark(h)
    ], () => {
      if (this.select) {
        this.select(this.value)
      }

      if (this.container.onSelect) {
        this.container.onSelect(this)
      }
    })
  }

  protected renderCheckmark (h: CreateElement) {
    if (this.type === 'multiple-option') {
      return <Checkbox value={this.selected} change={() => {
        this.select(this.value)
      }} />
    }
  }

  protected renderDetail (h: CreateElement) {
    return <span class='detail'>{this.detail}</span>
  }

  protected get optionStyles () {
    return ['option']
  }

}

@Component
export class ClearOption extends Option {

  protected renderCheckmark (h: CreateElement) {
    return <div>
      <Icon class='right-icon right-icon-clear' name={'util/close'} />
    </div>
  }
}

// Option containing a dropdown
@Component
export class DropdownOption extends Vue {

  @Prop({ required: true, type: [Element, String] })
  label

  opened: boolean = false

  constructor () {
    super()
  }

  mounted () {
    this.opened = isMobileBrowser()
  }

  render (h: CreateElement) {
    return <div class={`option dropdown-option ${this.opened ? 'opened' : ''}`}>
      <div class='stretch' onClick={this.clickDropdownOption}>
        {this.renderLabel(h)}
        {this.renderCaret(h)}
      </div>
      {this.opened ?
        <div class='dropdown-options-content'>
          {this.$slots.default}
        </div> : null}
    </div>
  }

  protected renderLabel (h: CreateElement) {
    return <p class='label withoutDetail'>{this.label}</p>
  }

  protected clickDropdownOption (e) {
    this.opened = !this.opened
    stopPropagation(e)
  }

  protected renderCaret (h: CreateElement) {
    return <div class='right-icon caret-icon'>
      {this.opened ? <Icon name={'util/caret-up'} /> : <Icon name={'util/caret-down'} />}
    </div>
  }

}
